import { render, staticRenderFns } from "./ElementCustomPage.vue?vue&type=template&id=3bc63d74&"
import script from "./ElementCustomPage.vue?vue&type=script&lang=js&"
export * from "./ElementCustomPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports